// @ts-nocheck
export const AsyncActionSuffix = {
  Pending: 'pending',
  Fulfilled: 'fulfilled',
  Rejected: 'rejected',
};

function parseErrorMessage(errorMessage) {
  try {
    const parsedError = JSON.parse(errorMessage);
    return parsedError.errorMessage || parsedError.message || errorMessage;
  } catch (e) {
    return errorMessage;
  }
}

export function createAction(type) {
  return (payload?, error?) => ({
    type,
    payload,
    error,
  });
}

export function createAsyncAction(type, payloadCreator) {
  return (...args) =>
    async dispatch => {
      dispatch(createAction(`${type}/${AsyncActionSuffix.Pending}`)());
      try {
        const result = await payloadCreator(...args);
        dispatch(createAction(`${type}/${AsyncActionSuffix.Fulfilled}`)(result));
        return result;
      } catch (e) {
        const message = e.response?.data?.message
          ? parseErrorMessage(e.response.data.message)
          : e.message;
        dispatch(createAction(`${type}/${AsyncActionSuffix.Rejected}`)(undefined, message));
        throw new Error(message);
      }
    };
}

export function createAsyncActionTypes(type) {
  return {
    pending: `${type}/${AsyncActionSuffix.Pending}`,
    fulfilled: `${type}/${AsyncActionSuffix.Fulfilled}`,
    rejected: `${type}/${AsyncActionSuffix.Rejected}`,
  };
}
